import "inputmask/dist/jquery.inputmask.min";
import { DISABLE_CLASS, ERROR_CLASS } from "../lib/constants";

const $FORM = $(".js-contact-form:first");

const $INPUTS_REQUIRED = $FORM.find(".input[required]");
const $CHECKBOX = $FORM.find(".js-contact-form-agree-input:first");
const $SUBMIT_BTN = $FORM.find(".js-contact-form-agree-btn:first");

const $SELECT_SHELL = $FORM.find(".js-select");
const $SELECT_BTN_SHELL = $SELECT_SHELL.find(
  ".js-select-current-btn-container"
);
const $SELECT_OPTIONS = $SELECT_SHELL.find(".js-select-option");

const $SERVICE_TITLE = $(".js-send-mgs-title-text");

const ERROR_PHONE = "error-phone";

const regExpEmail = /^[A-Z0-9._%+-]+@[A-Z0-9-]+.+\.[A-Z]{2,4}$/i;

const contactFormSubmit = () => {
  const $successBlock = $(".js-send-success:first");
  const $errorBlock = $(".js-send-error:first");

  const data = new FormData(document.querySelector(".js-contact-form"));

  $.ajax({
    url: "/bitrix/services/main/ajax.php?mode=ajax&c=zug:feedback&action=sendMessage&",
    processData: false,
    contentType: false,
    dataTypes: "json",
    method: "post",
    cache: false,
    async: false,
    data: data,
    success: function ({ errors }) {
      $SERVICE_TITLE.hide();

      let isError = false;

      if (errors.length) {
        errors.forEach(({ code }) => {
          isError = true;
          $FORM.hide();
          $errorBlock.show();

          if (code === 6) {
            console.log("ошибка капчи");
          }
        });
      }

      if (isError === false) {
        $FORM.hide();
        $successBlock.show();
      }
    },
  });
};

const contactForm = () => {
  let submitBtnClick = false;
  let valChange = false;

  let regExpEmailTrue = false;

  const phone = $('[data-name="phone"]');
  const email = $('[data-name="email"]');

  const phoneMask = () => {
    const checkPhone = () => {
      if (phone.parent().hasClass(ERROR_PHONE)) {
        phone.parent().removeClass(ERROR_PHONE);
      }

      isPhoneValid = true;
      checkFormFields();
    };

    phone.inputmask({
      mask: "+7(999)999-99-99",
      jitMasking: true,
      oncomplete: () => {
        phone.parent().removeClass("error-phone");
        isPhoneValid = true;
        checkFormFields();
      },
    });

    phone.on("keydown", function (e) {
      if (phone.val() === "+7(" && e.key.toString() === "7") {
        valChange = true;
      }

      if (phone.val() === "+7(8" && e.key.toString() === "8" && !valChange) {
        phone.val("+7(");
        valChange = true;
      } else {
        if (phone.val() === "") {
          valChange = false;
        }
      }
    });

    phone.on("change", function (e) {
      if (phone.val() !== "") {
        checkPhone();
      }
    });

    phone.on("input", function (e) {
      if (phone.val() !== "") {
        checkPhone();
      }
    });

    return false;
  };

  let isPhoneValid = phoneMask();

  const isPlaceholderVisible = () => {
    $INPUTS_REQUIRED.on("input", function () {
      const $t = $(this);

      const $tPlaceholder = $t
        .parent()
        .find(".js-contact-form-input-placeholder");

      if ($t.val().trim() === "") {
        phoneMask();
        $tPlaceholder.show();
      } else {
        $tPlaceholder.hide().removeClass(ERROR_CLASS);
      }

      checkFormFields();
    });
  };

  const isInputsValues = () => {
    let inputsWithVal = true;

    $.each($INPUTS_REQUIRED, function (_, el) {
      const $el = $(el);

      if (submitBtnClick) {
        if ($el.val().trim() === "") {
          $el
            .parent()
            .find(".js-contact-form-input-placeholder")
            .addClass(ERROR_CLASS);

          if ($el[0].name === "phone") {
            phone.parent().removeClass("error-phone");
          }

          if ($el[0].name === "email") {
            email.parent().removeClass("error-mail");
          }

          inputsWithVal = false;
        }
      } else {
        if ($el.val().trim() === "") {
          inputsWithVal = false;
        }
      }
    });

    return inputsWithVal;
  };

  const checkSelectValue = (submitBtnClick) => {
    let selected = false;

    if ($SELECT_SHELL.find("[selected]").length) {
      $SELECT_BTN_SHELL.removeClass(ERROR_CLASS);
      selected = true;
    } else {
      if (submitBtnClick) {
        $SELECT_BTN_SHELL.addClass(ERROR_CLASS);
      }
    }

    return selected;
  };

  const checkFormFieldsBySelectClick = () => {
    $SELECT_OPTIONS.on("click", function () {
      checkFormFields();
    });
  };

  const checkFormFields = () => {
    let isPrivateAccept = $CHECKBOX.prop("checked");
    const isSelectValue = checkSelectValue(submitBtnClick);
    let allInputsWithValues = isInputsValues();

    if (
      ($FORM.length > 0 &&
        !submitBtnClick &&
        allInputsWithValues &&
        isPrivateAccept &&
        isPhoneValid &&
        regExpEmailTrue) ||
      ($FORM.length &&
        !submitBtnClick &&
        allInputsWithValues &&
        isPrivateAccept &&
        isPhoneValid &&
        regExpEmailTrue &&
        isSelectValue)
    ) {
      $SUBMIT_BTN.removeClass(DISABLE_CLASS);
    } else {
      $SUBMIT_BTN.addClass(DISABLE_CLASS);
      submitBtnClick = false;

      if ($FORM.length > 0) {
        return (
          allInputsWithValues &&
          isPrivateAccept &&
          isPhoneValid &&
          regExpEmailTrue
        );
      } else {
        return (
          allInputsWithValues &&
          isPrivateAccept &&
          isPhoneValid &&
          regExpEmailTrue &&
          isSelectValue
        );
      }
    }
  };

  const checkInputValue = function (value, regexp) {
    if (regexp.test(value)) return true;
  };

  const checkEmailValue = () => {
    const checkEmail = checkInputValue(email.val(), regExpEmail);

    if (!checkEmail) {
      email.parent().addClass("error-mail");
      regExpEmailTrue = false;
    } else {
      email.parent().removeClass("error-mail");
      regExpEmailTrue = true;
    }
  };

  const checkInputValByFocusout = () => {
    $.each($INPUTS_REQUIRED, function (_, el) {
      const $el = $(el);

      $el.on("focusout", function () {
        if ($el.val().trim() === "") {
          $el
            .parent()
            .find(".js-contact-form-input-placeholder")
            .addClass(ERROR_CLASS);

          if ($el[0].name === "phone") {
            phone.parent().removeClass("error-phone");
          }

          if ($el[0].name === "email") {
            email.parent().removeClass("error-mail");
          }
        }
      });
    });
  };

  $INPUTS_REQUIRED.val("");

  email.on("input", () => {
    checkEmailValue();
  });

  phone.on("input", () => {
    phone.parent().addClass("error-phone");
    isPhoneValid = false;
    checkFormFields();
  });

  isPlaceholderVisible();
  checkInputValByFocusout();
  checkFormFieldsBySelectClick();

  $CHECKBOX.on("click", function () {
    checkFormFields();
  });

  $SUBMIT_BTN.on("click", function () {
    submitBtnClick = true;

    if (checkFormFields()) {
      contactFormSubmit();
    }
  });
};

export const contactWithUsFunctions = () => {
  contactForm();
};
